var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9492 22.0007C15.5942 22.0007 16.9162 22.0007 17.8662 21.2447C18.8152 20.4877 19.1182 19.1937 19.7232 16.6047L21.6412 8.40765C21.9762 6.97465 22.1442 6.25766 21.8392 5.73766C21.2872 4.79666 19.8792 5.00066 18.9592 5.00066",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.00061C2 5.70061 2 4.05061 3.025 3.02561C4.05 2.00061 5.7 2.00061 9 2.00061H12C15.3 2.00061 16.95 2.00061 17.975 3.02561C19 4.05061 19 5.70061 19 9.00061V15.0006C19 18.3006 19 19.9506 17.975 20.9756C16.95 22.0006 15.3 22.0006 12 22.0006H9C5.7 22.0006 4.05 22.0006 3.025 20.9756C2 19.9506 2 18.3006 2 15.0006V9.00061Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6C11.5609 6 12.5783 6.42143 13.3284 7.17157C14.0786 7.92172 14.5 8.93913 14.5 10C14.5 11.0609 14.0786 12.0783 13.3284 12.8284C12.5783 13.5786 11.5609 14 10.5 14M10.5 6C9.43913 6 8.42172 6.42143 7.67157 7.17157C6.92143 7.92172 6.5 8.93913 6.5 10C6.5 11.0609 6.92143 12.0783 7.67157 12.8284C8.42172 13.5786 9.43913 14 10.5 14M10.5 6C9.672 6 9 7.79 9 10C9 12.21 9.672 14 10.5 14M10.5 6C11.328 6 12 7.79 12 10C12 12.21 11.328 14 10.5 14M7 17H14",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.674e22a26b50e2931fcac7f5662cfe2c.svg";
export { ForwardRef as ReactComponent };